
import { toString as toString_1, Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { DTO_CreateProcedureDto_$reflection, DTO_CreateProcedureDto, ProcedureTrigger, ProcedureEntityReferenceDto_$reflection, DTO_ManualHookDto_$reflection } from "../../Shared/Procedure.js";
import { record_type, union_type, class_type, option_type, anonRecord_type, string_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ProcedureId, FormState__setValidationResponse_5219762A, ProcedureTemplateId, FormState__startLoading, FormState_get_empty, RequestedValue$1, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { map, isEmpty, empty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { singleton, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Select } from "../../Components/Select.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { TextButton } from "../../Components/Button.js";
import { OpenProcedureModal } from "./Form/View.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ManualHooksFetched", "SetSelectedProcedureTemplate", "StartProcedure", "ProcedureStarted", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Procedure.StartProcedureDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(list_type(DTO_ManualHookDto_$reflection()))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", DTO_ManualHookDto_$reflection()]))]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(EntityReference, ManualHooks, SelectedProcedureTemplate, CreatedProcedureId, FormState) {
        super();
        this.EntityReference = EntityReference;
        this.ManualHooks = ManualHooks;
        this.SelectedProcedureTemplate = SelectedProcedureTemplate;
        this.CreatedProcedureId = CreatedProcedureId;
        this.FormState = FormState;
    }
}

function State_$reflection() {
    return record_type("Widgets.Procedure.StartProcedureDialog.State", [], State, () => [["EntityReference", ProcedureEntityReferenceDto_$reflection()], ["ManualHooks", RequestedValue$1_$reflection(list_type(DTO_ManualHookDto_$reflection()))], ["SelectedProcedureTemplate", option_type(anonRecord_type(["label", string_type], ["value", DTO_ManualHookDto_$reflection()]))], ["CreatedProcedureId", option_type(string_type)], ["FormState", FormState_$reflection()]]);
}

function init(entityReference, labelIds) {
    return [new State(entityReference, new RequestedValue$1(0, []), undefined, undefined, FormState_get_empty()), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_ManualHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/manual", toString(0, Auto_generateBoxedEncoder_437914C6(list_type(class_type("System.Guid")), undefined, undefined, undefined)(labelIds))], (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
}

function update(msg, state) {
    let body;
    switch (msg.tag) {
        case 1:
            return [new State(state.EntityReference, state.ManualHooks, msg.fields[0], state.CreatedProcedureId, state.FormState), Cmd_none()];
        case 2: {
            const matchValue = state.SelectedProcedureTemplate;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const selected_1 = matchValue;
                const dto = new DTO_CreateProcedureDto(undefined, state.EntityReference, new ProcedureTrigger(0, []));
                return [new State(state.EntityReference, state.ManualHooks, state.SelectedProcedureTemplate, state.CreatedProcedureId, FormState__startLoading(state.FormState)), (body = toString(0, Auto_generateBoxedEncoder_437914C6(DTO_CreateProcedureDto_$reflection(), undefined, undefined, undefined)(dto)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_1) => {
                        const pr = response_1.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), [concat("/api/procedure-templates/", toString_1(new ProcedureTemplateId(selected_1.value.ProcedureTemplateId)), ..."/procedure"), body], (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1]))))];
            }
        }
        case 3: {
            const response_3 = msg.fields[0];
            if (response_3.tag === 1) {
                return [new State(state.EntityReference, state.ManualHooks, state.SelectedProcedureTemplate, state.CreatedProcedureId, FormState__setValidationResponse_5219762A(state.FormState, response_3.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.EntityReference, state.ManualHooks, state.SelectedProcedureTemplate, response_3.fields[0], FormState_get_empty()), Cmd_none()];
            }
        }
        case 4:
            return [new State(state.EntityReference, state.ManualHooks, state.SelectedProcedureTemplate, state.CreatedProcedureId, FormState_get_empty()), Cmd_none()];
        default: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.EntityReference, new RequestedValue$1(1, [empty()]), state.SelectedProcedureTemplate, state.CreatedProcedureId, state.FormState), Cmd_none()];
            }
            else {
                return [new State(state.EntityReference, new RequestedValue$1(1, [response.fields[0]]), state.SelectedProcedureTemplate, state.CreatedProcedureId, state.FormState), Cmd_none()];
            }
        }
    }
}

export function StartProcedureDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.EntityReference, props.LabelIds), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const matchValue = state_1.CreatedProcedureId;
    if (matchValue == null) {
        return createElement(Dialog, (Title = t("procedure.manual_start.title"), {
            Body: toList(delay(() => {
                let elems;
                const matchValue_1 = state_1.ManualHooks;
                if (matchValue_1.tag === 0) {
                    return singleton(createElement(Skeleton, {
                        Variant: "normal",
                    }));
                }
                else {
                    const hooks = matchValue_1.fields[0];
                    return isEmpty(hooks) ? singleton(reactElement("p", {
                        className: join(" ", ["text-gray-500", "text-sm"]),
                        children: t("procedure.manual_start.no_procedures"),
                    })) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = [reactElement("p", {
                        className: join(" ", ["text-sm", "text-gray-600"]),
                        children: t("procedure.manual_start.description"),
                    }), createElement(Select, {
                        ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                        IsClearable: true,
                        Label: t("procedure.manual_start.select_procedure"),
                        NoOptionsMessage: "procedure.manual_start.no_procedures",
                        OnChange: (selected) => {
                            dispatch(new Msg(1, [selected]));
                        },
                        Options: map((hook) => ({
                            label: hook.ProcedureTemplateName,
                            value: hook,
                        }), hooks),
                        PlaceholderKey: "general.select",
                        TestId: "start-procedure-select",
                        Value: unwrap(state_1.SelectedProcedureTemplate),
                    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
                }
            })),
            Controls: ofArray([createElement(TextButton, {
                ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                Label: t("general.cancel"),
                OnClick: props.OnClose,
                TestId: "close-start-procedure-dialog",
                Variant: "blueButton",
            }), createElement(TextButton, {
                ComponentState: (state_1.FormState.IsLoading ? true : (state_1.SelectedProcedureTemplate == null)) ? "disabled" : "enabled",
                Label: t("procedure.manual_start.start"),
                OnClick: () => {
                    dispatch(new Msg(2, []));
                },
                TestId: "confirm-start-procedure",
                Variant: "blueButton",
            })]),
            IsOpen: props.IsOpen,
            OnClose: props.OnClose,
            Title: Title,
        }));
    }
    else {
        return createElement(OpenProcedureModal, {
            IsOpen: true,
            OnCancelCallback: () => {
                props.SuccessCallback();
                props.OnClose();
            },
            OnClose: props.OnClose,
            OnSuccessCallback: () => {
                props.SuccessCallback();
                props.OnClose();
            },
            ProcedureId: new ProcedureId(parse(matchValue)),
        });
    }
}

